export default __webpack_public_path__ + "static/media/filgreen1.1a5d97fe.png";